import React from 'react'
import './Home.scss'
import Upload from './Upload/Upload'

const Home = () => {
  return (
    <div className='home'>
    <Upload/>
    </div>
  )
}

export default Home